module.exports = __webpack_public_path__ + "img/login_right_bac.079c3d85.png";